import { useContext, useEffect, useMemo } from "react";
import { getData } from "src/actions/getData";
import shopContext from "src/context/shopContext";
import Table from "src/components/Table";
import PageHeader from "src/components/PageHeader";
import { numberWithCommas } from "src/utils/thousandSeprator";
import { TbReload } from "react-icons/tb";
import { get } from "src/services/HttpClient";
import { completedStatuses } from "src/settings/config";

export default function ReturningCustomer() {
    const { orders, setOrders } = useContext(shopContext)

    useEffect(() => {
        const controller = new AbortController(); // برای لغو درخواست
        const signal = controller.signal;

        if (!orders) {
            getData(setOrders, "/orders", {}, signal);
        }

        return () => {
            controller.abort();
        };
    }, [])

    // تحلیل مشتریان بر اساس شماره تلفن
    const customerAnalysis = useMemo(() => {
        if (!orders || !Array.isArray(orders)) return null;

        // فیلتر سفارش‌ها بر اساس وضعیت‌های تکمیل شده
        const validStatuses = completedStatuses.split(',');
        const filteredOrders = orders.filter(order => 
            validStatuses.includes(order.status)
        );

        // گروه‌بندی سفارش‌ها بر اساس شماره تلفن
        const customerGroups = filteredOrders.reduce((acc, order) => {
            const phoneNumber = order.phoneNumber;
            if (!phoneNumber || phoneNumber === "'02100000000") return acc;

            if (!acc[phoneNumber]) {
                acc[phoneNumber] = {
                    phoneNumber: phoneNumber,
                    fullName: order.fullName,
                    email: order.email,
                    city: order.city,
                    state: order.state,
                    orders: [],
                    totalAmount: 0,
                    orderCount: 0
                };
            }

            acc[phoneNumber].orders.push(order);
            acc[phoneNumber].totalAmount += parseInt(order.total) || 0;
            acc[phoneNumber].orderCount += 1;

            return acc;
        }, {});

        // تبدیل به آرایه و محاسبه میانگین
        return Object.values(customerGroups).map(customer => ({
            ...customer,
            averageOrderAmount: customer.orderCount > 0
                ? Math.round(customer.totalAmount / customer.orderCount)
                : 0,
            lastOrderDate: customer.orders
                .sort((a, b) => new Date(b.date_created) - new Date(a.date_created))[0]?.date_created_jalali || "---"
        })).sort((a, b) => b.orderCount - a.orderCount); // مرتب‌سازی بر اساس تعداد سفارش
    }, [orders]);

    const columns = [
        {
            id: "phoneNumber",
            cell: (info) => info.getValue() || "---",
            header: "شماره تلفن",
        },
        {
            id: "fullName",
            cell: (info) => info.getValue() || "---",
            header: "نام کامل",
        },
        {
            id: "email",
            cell: (info) => info.getValue() || "---",
            header: "ایمیل",
        },
        {
            id: "state",
            cell: (info) => info.getValue() || "---",
            header: "استان",
        },
        {
            id: "city",
            cell: (info) => info.getValue() || "---",
            header: "شهر",
        },
        {
            id: "orderCount",
            cell: (info) => info.getValue(),
            header: "تعداد سفارش",
        },
        {
            id: "totalAmount",
            cell: (info) => info.getValue() ? numberWithCommas(info.getValue()) + " تومان" : "---",
            header: "مجموع خرید",
        },
        {
            id: "averageOrderAmount",
            cell: (info) => info.getValue() ? numberWithCommas(info.getValue()) + " تومان" : "---",
            header: "میانگین سفارش",
        },
        {
            id: "lastOrderDate",
            cell: (info) => info.getValue(),
            header: "آخرین سفارش",
        },
    ];

    return (
        <>
            <PageHeader
                title="مشتریان بازگشتی"
                // btnTitle="بروزرسانی"
                // handleClick={async () => {
                //     setOrders();
                //     await get("/orders/s/purgeCache")
                //     setTimeout(() => {
                //         getData(setOrders, "/orders");
                //     }, 500);
                // }}
                // isBtnLoading={!orders}
                // btnIcon={<TbReload className="ml-1" size="22" />}
            />

            <Table
                columns={columns}
                data={customerAnalysis}
                CSVExportPermission="exportReturningCustomers"
                tableName="returningCustomers"
            />
        </>
    )
}
